module.exports = "/build/images/star.png?32cceec6a826cc74674f2f272c837239";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/star.png
// module id = 390
// module chunks = 0